import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "speel opnieuw af"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 15h2a5.5 5.5 0 1 0 6-6V7a7.5 7.5 0 1 1-8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 3v9.8l-5-5z"
}))));